import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-two-col-layout',
  templateUrl: './two-col-layout.component.html',
  styleUrls: ['./two-col-layout.component.css']
})
export class TwoColLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
